import { render, staticRenderFns } from "./TestimonialView.vue?vue&type=template&id=11393f68&scoped=true&"
import script from "./TestimonialView.vue?vue&type=script&lang=js&"
export * from "./TestimonialView.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialView.vue?vue&type=style&index=0&id=11393f68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11393f68",
  null
  
)

export default component.exports